import * as React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Masonry from '@mui/lab/Masonry';
import { styled } from '@mui/material/styles';
import { motion } from 'framer-motion';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme, useMediaQuery } from "@mui/material";
// Local images
const car = 'https://dbqa318yoj3nn.cloudfront.net/Robitic_Car.png';
const glasses = 'https://dbqa318yoj3nn.cloudfront.net/Smart_glass.png';
const pen = 'https://dbqa318yoj3nn.cloudfront.net/3D_pen.png';
const boy = 'https://dbqa318yoj3nn.cloudfront.net/boy_glasses.png';
const print = 'https://dbqa318yoj3nn.cloudfront.net/3D_drwaing.png';
const solar = 'https://dbqa318yoj3nn.cloudfront.net/Auto_solar.png';



const Label = styled(Paper)(({ theme }) => ({
  
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(0.5),
  textAlign: 'center',
  color: (theme.vars || theme).palette.text.secondary,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  ...theme.applyStyles?.('dark', {
    backgroundColor: '#1A2027',
  }),
}));

export default function ImageMasonry() {
  const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [open, setOpen] = React.useState(false);
  const [selectedImg, setSelectedImg] = React.useState('');

  const handleOpen = (img) => {
    setSelectedImg(img);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImg('');
  };

  return (
    <Box sx={{ width: '99vw', minHeight: 'auto', backgroundColor: '#f9f9f9' }}>
    <Box sx={{ width:isMobile?'99vw':'70vw', minHeight: 'auto', margin: '0 auto', backgroundColor: '#f9f9f9', p: 2 }}>
      <Masonry columns={3} spacing={2}>
        {itemData.map((item, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, scale: 0.9, y: 20 }}
            whileInView={{ opacity: 1, scale: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            whileHover={{
              scale: 1.05,
              y: -4,
              transition: { type: 'tween', duration: 0.2, ease: 'easeInOut' },
            }}
            transition={{
              type: 'spring',
              stiffness: 70,
              damping: 20,
              delay: index * 0.1,
            }}
            style={{
              cursor: 'pointer',
              borderRadius: 15,
              overflow: 'hidden',
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
            onClick={() => handleOpen(item.img)}
          >
            <img
              src={item.img}
              alt={item.title}
              loading="lazy"
              style={{
                display: 'block',
                width: '100%',
                borderRadius: 15,
              }}
            />
          </motion.div>
        ))}
      </Masonry>

      {/* Modal with larger image */}
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="md"
        fullWidth
        sx={{ padding: 0 }}
      >
        <Box sx={{ position: 'relative' }}>
          <IconButton
            onClick={handleClose}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              zIndex: 1,
              backgroundColor: '#fff',
            }}
          >
            <CloseIcon />
          </IconButton>
          <img
            src={selectedImg}
            alt="Zoomed"
            style={{
              width: '100%',
              height: 'auto',
              display: 'block',
            }}
          />
        </Box>
      </Dialog>
    </Box>
    </Box>
  );
}

const itemData = [
  { img: car, title: 'Robotic Car' },
  { img: glasses, title: 'Smart Glass - Girl' },
  { img: pen, title: '3D Pen' },
  { img: boy, title: 'Smart Glass - Boy' },
  { img: print, title: '3D Drawing' },
  { img: solar, title: 'Solar Light' },
];
